import "@babel/polyfill";
import "unfetch/polyfill";
import "intersection-observer";
import Vue from "vue";
import { sync } from "vuex-router-sync";
import VueObserveVisibility from "vue-observe-visibility";
import PortalVue from "portal-vue";
import VueMatomo from "vue-matomo";
import replaceAll from "string.prototype.replaceall";
import router from "@/router";
import store from "@/store";
import i18n from "@/i18n";
import App from "./App.vue";
import "@/assets/styles/index.css";
import getMatomoConfig from "../matomo.config";

// Polyfill for String.prototype.replaceAll
if (!String.prototype.replaceAll) {
  // eslint-disable-next-line no-extend-native
  String.prototype.replaceAll = replaceAll.getPolyfill();
}

if (window.navigator && navigator.serviceWorker) {
  // Removes broken service worker registrations
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach((registration: ServiceWorkerRegistration) => {
      registration.unregister();
    });
  });
}

Vue.use(VueObserveVisibility);
Vue.use(PortalVue);

// sync router in vuex state
sync(store, router);

Vue.config.productionTip = false;

async function awaitStageConfig() {
  if (!store.state.stageconfig.config) {
    await store.dispatch("stageconfig/fetchStageConfig");
  }
}

awaitStageConfig()
  .then(function success() {
    /**
     * Matomo (Tracking) Configuration
     */
    if (store.state.stageconfig.config.features.enableMatomoTracking) {
      Vue.use(VueMatomo, getMatomoConfig(router));
    }

    new Vue({
      router,
      store,
      i18n,
      render: h => h(App)
    }).$mount("#app");
  })
  .catch(err => console.log(err));
